module.exports = __webpack_public_path__ + "static/Q8Answer1_dontdance_ayo_ogunseinde-0ce949e9d0305c16444cd673dbc7c638.jpg";